import React, { useState, useEffect } from "react";
import "../table.css";
import Loading from "../Loading.js";
import url from "../../constants/URL";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroller";

const SalesHistory = (props) => {
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState([]);
  const [allLoaded, setAllLoaded] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const token = await JSON.parse(localStorage.getItem("persist:auth")).token;
    fetch(`${url}/shop/history/${props.auth.seller._id}/?skip=${history.length}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }).then(async (resp) => {
      const data = await resp.json();
      if (data.length < 10) {
        setAllLoaded(true);
      }
      if (history.length === 0) {
        setHistory(data);
        setLoading(false);
      } else {
        setHistory([...data, ...history]);
        setLoadingMore(false);
      }
    });
  };

  const loadMoreItems = () => {
    setLoadingMore(true);
    fetchData();
  };

  if (loading) {
    return <Loading />;
  }
  if (!loading && history.length === 0) {
    return <div>No Order Completed Yet</div>;
  }
  return (
    <div className="container">
      <p style={{ marginLeft: 40, fontSize: 24 }}>Orders History</p>
      <hr />
      <div className="table_container">
        <table>
          <thead>
          <tr>
            <th className="table_head">Number</th>
            <th className="table_head">Order Id</th>
            <th className="table_head">Buyer Name</th>
            <th className="table_head">Delivered At</th>
            <th className="table_head">Address</th>
          </tr>
          </thead>
          <InfiniteScroll
            pageStart={0}
            loadMore={() => {
              if (!loadingMore) {
                loadMoreItems();
              }
            }}
            hasMore={!allLoaded}
            threshold={8}
            style={{ display: "table-row-group" }}
          >
            {history.map((val, key) => {
              return (
                <tr key={key}>
                  <td>{key + 1}</td>
                  <td>
                    <Link
                      to={`/receipt/${val._id}`}
                      style={{
                        color: "cornflowerblue",
                        fontStyle: "italic",
                        textDecoration: "underline",
                        textDecorationColor: "cornflowerblue",
                      }}
                    >
                      {val._id}
                    </Link>
                  </td>

                  <td>{val.buyer.name}</td>
                  <td>{new Date(val.receivedAt).toLocaleDateString()}</td>
                  <td>{val.address}</td>
                </tr>
              );
            })}
          </InfiniteScroll>
        </table>
      </div>
      {loadingMore && (
        <div>
          <h3 style={{ color: "green", textAlign: "center",paddingBottom:30 }}>
            Loading More...
          </h3>
        </div>
      )}
    </div>
  );
};
const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(SalesHistory);
